<template>
  <div>
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{on, attrs}">
        <v-text-field
          dense
          outlined
          :value="getValue"
          :label="label"
          readonly
          v-bind="attrs"
          v-on="on"
          :append-icon="!readonly && value ? 'fa-window-close' : undefined"
          @click:append="$emit('change', null)"
          :error-messages="errorMessages"
        />
      </template>
      <v-date-picker v-if="!readonly" v-model="date" @change="change" />
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    errorMessages: {
      type: String,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    value: {},
  },
  computed: {
    getValue() {
      return this.value ? new Date(this.value).toLocaleDateString('pt-BR') : null;
    },
  },
  data() {
    return {
      date: null,
      menu: false,
    };
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'));
    },
  },
  methods: {
    change(date) {
      this.$refs.menu.save(date);
      this.$emit('change', date+"T00:00:00");
    },
  },
};
</script>

<style scoped>
</style>